/**
 * Opções disponíveis na solicitação enviada.
 */
export enum ActionIconEnum {
  BACK = 'BACK',
  HOME = 'HOME',
  FAQ = 'FAQ',
  CLOSE = 'CLOSE',
}
